import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { INTEGRATIONS } from '../../../util/integrations';

import './IntegrationBadge.scss';

export class IntegrationBadge extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { user, app } = this.props;

    return (
      <div className="integration_badge">
        <img className="connection_icon" src={INTEGRATIONS[app].icon} alt="#"/><strong>{INTEGRATIONS[app].name}</strong>  {user[INTEGRATIONS[app].field]}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    app: state.app.app,
    user: state.auth.user,
  };
};

export default connect(mapStateToProps)(IntegrationBadge);
